export default __webpack_public_path__ + "static/media/spark_75.c7b97f72.png";